import TravelPassDetails from '@/components/manage/travel-passes/TravelPassDetails';
import { Typography } from '@/components/primitives/Typography';
import {
  manageFlowBookingSelector,
  manageFlowTravelAccountsMapSelector,
} from '@/features/manage/manageSelectors';
import { useSeparateNonTripOffersBasedOnType } from '@/hooks/useSeparateNonTripOffersBasedOnType';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { breakpoints } from '@/utils/breakpoints';
import { type FC } from 'react';
import { useMediaQuery } from 'react-responsive';

interface TravelPassDetailsProps {}

const TravelPasses: FC<TravelPassDetailsProps> = () => {
  const booking = useSelector(manageFlowBookingSelector);
  const travelAccountsMap = useSelector(manageFlowTravelAccountsMapSelector);
  const { travelPass, multiRide } = useSeparateNonTripOffersBasedOnType(
    booking?.nonTripOffers,
    travelAccountsMap
  );
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  return (
    <div className="flex flex-1 flex-col">
      <Typography
        variant={isLaptopOrBigger ? 'heading2' : 'subtitle'}
        className="mb-7"
        asChild
      >
        <h1>
          <TransText i18nKey="bookedTravelPasses" />
        </h1>
      </Typography>
      <div className="flex flex-col gap-3">
        {[...travelPass, ...multiRide].map((data, key) => (
          <TravelPassDetails data={data} key={key} />
        ))}
      </div>
    </div>
  );
};

export default TravelPasses;
